var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('header',[_c('img',{attrs:{"src":"/icons/qr-white-logo.svg","alt":""}}),_vm._t("header")],2),_c('main',[_c('p',[_vm._v(_vm._s(_vm.$t('demo.mobile')))]),_vm._t("hero")],2),_vm._t("qr-pic")],2)}
var staticRenderFns = []

export { render, staticRenderFns }